import React from "react";
import { TextSchema, DatePicker } from "../InputSchema";

const JobDetailsSchemaInput = ({
  schemaProps,
  handleChangeFields,
  requiredFields,
  handleDatePicker,
}) => {
  return (
    <div>
      {/* <h2 className="text-center mb-4">Job Details Form</h2> */}
      
      <TextSchema
        label="Name"
        name="name"
        onTextInputChange={handleChangeFields}
        textValue={schemaProps?.name}
        placeholderValue="Enter your full name"
        required={requiredFields?.includes("name")}
      />

      <TextSchema
        label="Institute Name"
        name="institute_name"
        onTextInputChange={handleChangeFields}
        textValue={schemaProps?.institute_name}
        placeholderValue="Enter institute name"
        required={requiredFields?.includes("institute_name")}
      />

        <DatePicker
          selected={schemaProps?.completion_date}
          onChange={(value, ev) => {
          handleDatePicker("completion_date", value, ev);
          }}
          name="completion_date"
          label="Completion Date"
          required={requiredFields.includes("completion_date")}
          />

      <TextSchema
        label="Score"
        name="score"
        onTextInputChange={handleChangeFields}
        textValue={schemaProps?.score}
        placeholderValue="Enter score"
        required={requiredFields?.includes("score")}
      />

      <TextSchema
        label="Level"
        name="level"
        onTextInputChange={handleChangeFields}
        textValue={schemaProps?.level}
        placeholderValue="Enter level"
        required={requiredFields?.includes("level")}
      />

      <TextSchema
        label="Organization Name"
        name="organization_name"
        onTextInputChange={handleChangeFields}
        textValue={schemaProps?.organization_name}
        placeholderValue="Enter organization name"
        required={requiredFields?.includes("organization_name")}
      />

<DatePicker
          selected={schemaProps?.start_date}
          onChange={(value, ev) => {
          handleDatePicker("start_date", value, ev);
          }}
          name="start_date"
          label="Start Date"
          required={requiredFields.includes("start_date")}
          />

<DatePicker
          selected={schemaProps?.end_date}
          onChange={(value, ev) => {
          handleDatePicker("end_date", value, ev);
          }}
          name="end_date"
          label="End Date"
          required={requiredFields.includes("end_date")}
          />

      <TextSchema
        label="Role"
        name="role"
        onTextInputChange={handleChangeFields}
        textValue={schemaProps?.role}
        placeholderValue="Enter role"
        required={requiredFields?.includes("role")}
      />
    </div>
  );
};

export default JobDetailsSchemaInput; 